import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { Tpl3plService } from '../../../services/tpl3pl.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { RawResponseModalComponent } from '../shared/raw-response-modal/raw-response-modal.component';

@Component({
	selector: 'app-tpl3pl-open-orders',
	templateUrl: './tpl3pl-open-orders.component.html',
	styleUrls: ['./tpl3pl-open-orders.component.scss']
})
export class Tpl3plOpenOrdersComponent implements OnInit, AfterViewInit {
	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;

	displayedColumns: string[] = ['pgs_orderno', 'status', 'so', 'po', 'consignee', 'destination', 'warehouse', 'createddate', 'RoutedDate', 'ScheduledPickUpDate'];
	dataSource = new MatTableDataSource<any>([]);
	loading = false;
	rawLoading = false;
	errorMessage: string | null = null;

	constructor(
		private tpl3plService: Tpl3plService,
		private globalSearchService: GlobalSearchService,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.loadOpenOrders();
	}

	ngAfterViewInit(): void {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	loadOpenOrders(): void {
		this.loading = true;
		this.errorMessage = null;
		this.tpl3plService.getOpenB2BOrders().subscribe({
			next: (result) => {
				this.loading = false;
				if (result.success && Array.isArray(result.data)) {
					this.dataSource.data = result.data;
				} else {
					this.dataSource.data = [];
					this.errorMessage = (result as any).message || 'No data returned';
				}
			},
			error: (err) => {
				this.loading = false;
				this.dataSource.data = [];
				this.errorMessage = err?.error?.message || err?.message || 'Failed to load open B2B orders';
				this.globalSearchService.showNotification(this.errorMessage, 'danger', 'bottom', 'right');
			}
		});
	}

	getStatusBadgeClass(item: any): string {
		const s = String(item?.status ?? item?.Status ?? item?.OrderStatus ?? '').toLowerCase();
		if (s === 'pending' || s === 'open') return 'badge-warning';
		if (s === 'shipped' || s === 'complete' || s === 'closed') return 'badge-success';
		if (s === 'error' || s === 'failed' || s === 'cancelled') return 'badge-danger';
		return 'badge-secondary';
	}

	formatDate(value: string | number | Date | null | undefined): string {
		if (value == null || value === '') return '-';
		const d = typeof value === 'number' || typeof value === 'string' ? new Date(value) : value;
		return isNaN(d.getTime()) ? '-' : d.toLocaleDateString(undefined, { dateStyle: 'short' });
	}

	openRawRequestResponse(): void {
		this.rawLoading = true;
		this.tpl3plService.getOpenB2BOrdersRaw().subscribe({
			next: (res) => {
				this.rawLoading = false;
				if (!res.success) {
					this.globalSearchService.showNotification(res.message || 'Could not load raw response', 'warning', 'bottom', 'right');
					return;
				}
				this.dialog.open(RawResponseModalComponent, {
					width: '720px',
					maxWidth: '96vw',
					maxHeight: '90vh',
					data: {
						context: 'open_orders',
						content: {
							request_payload: res.request_payload,
							response: res.response
						},
						onSent: () => this.loadOpenOrders()
					},
					panelClass: 'raw-response-dialog'
				});
			},
			error: () => {
				this.rawLoading = false;
				this.globalSearchService.showNotification('Could not load raw request/response', 'danger', 'bottom', 'right');
			}
		});
	}
}
